export default "__VITE_ASSET__03bed7ce__"